const NUMERIC_VALUE_EPSILON = 0.000001;

export function areTimelineKeyframeValuesEqual(
  left: unknown,
  right: unknown
): boolean {
  if (typeof left === "number" && typeof right === "number") {
    return Math.abs(left - right) <= NUMERIC_VALUE_EPSILON;
  }

  if (Object.is(left, right)) {
    return true;
  }

  if (Array.isArray(left) || Array.isArray(right)) {
    if (!Array.isArray(left) || !Array.isArray(right)) {
      return false;
    }

    return (
      left.length === right.length &&
      left.every((entry, index) =>
        areTimelineKeyframeValuesEqual(entry, right[index])
      )
    );
  }

  if (isComparableObject(left) || isComparableObject(right)) {
    if (!isComparableObject(left) || !isComparableObject(right)) {
      return false;
    }

    const leftKeys = Object.keys(left);
    const rightKeys = Object.keys(right);
    if (leftKeys.length !== rightKeys.length) {
      return false;
    }

    return leftKeys.every(
      (key) =>
        Object.prototype.hasOwnProperty.call(right, key) &&
        areTimelineKeyframeValuesEqual(left[key], right[key])
    );
  }

  return false;
}

export function doesKeyframeSegmentChangeValue(params: {
  startValue: unknown;
  startOutgoingValue: unknown;
  endValue: unknown;
}): boolean {
  const outgoingValue =
    params.startOutgoingValue === undefined
      ? params.startValue
      : params.startOutgoingValue;

  return (
    !areTimelineKeyframeValuesEqual(params.startValue, outgoingValue) ||
    !areTimelineKeyframeValuesEqual(outgoingValue, params.endValue)
  );
}

function isComparableObject(
  value: unknown
): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
